function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h15v20H0V5Z",
    style: {
      fill: "#063"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.33,12.5c-1.381-2.391-4.439-3.211-6.83-1.83s-3.211,4.439-1.83,6.83,4.439,3.211,6.83,1.83c.76-.439,1.391-1.07,1.83-1.83-1.381,1.724-3.898,2.003-5.622.622-1.725-1.381-2.003-3.898-.623-5.622s3.898-2.003,5.622-.622c.23.183.439.392.623.622M19.523,15l-4.523-1.469,2.795,3.847v-4.755l-2.795,3.846,4.523-1.469Z",
    style: {
      fill: "#d21034"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/DZ.6a8e9cba107231bd2b2ac2cdc7d2e875.svg";
export { ForwardRef as ReactComponent };